<template>
  <div class="p-3">
    <div class="createQuestion">
      <h5 class="text-center pb-4">
        {{ $t("question_list.label.explain_answer") }}
      </h5>
      <div class="explain">
        <div class="explain-textArena">
          <textarea
            v-model="explain_notVuex"
            @keyup="charCount()"
            name=""
            id=""
            rows="5"
            maxlength="1500"
            :placeholder="$t('question_list.label.placeholder_explain')"
            class="answer-input__text_explain mt-2"
          ></textarea>
          <!-- <span>{{ totalCharacterExplain }} / 1500</span> -->
        </div>
        <div class="row justify-content-around">
          <div class="col left-embed p-0">
            <div
              class="d-flex flex-column align-items-center embed-image-video"
            >
              <ion-icon
                style="font-size: 60px; margin-bottom: 10px"
                name="cloud-upload-outline"
                v-if="
                  !fileExplain_img &&
                    !fileExplain_pdf &&
                    !editQuestion.data.explain_path
                "
              ></ion-icon>
              <label
                v-if="
                  !fileExplain_img &&
                    !fileExplain_pdf &&
                    !editQuestion.data.explain_path
                "
                class="label-uploadImage"
                for="uploadExplainImage"
              >
                {{ $t("question_list.label.upload_file_pdf") }}
              </label>
              <input
                v-if="
                  !fileExplain_img &&
                    !fileExplain_pdf &&
                    !editQuestion.data.explain_path
                "
                type="file"
                @change="handleExplainUpload"
                class=""
                id="uploadExplainImage"
              />
              <div v-else id="preview" class="">
                <img
                  v-if="editQuestion.data.explain_s3 && isImage === true"
                  :src="editQuestion.data.explain_s3"
                />
              <div class="question_explain_pdf">
                  <a
                    v-if="editQuestion.data.explain_s3 && isImage === false"
                    :href="editQuestion.data.explain_s3"
                  >
                    <img
                      style="width:200px"
                      src="../../../assets/images/file_pdf.svg.webp"
                    />
                    <p>
                      {{ namePdf }}
                    </p>
                  </a>
                </div>

                <img v-if="fileExplain_img" :src="fileExplain_img" />
                <div class="question_explain_pdf">
                  <img
                    v-if="fileExplain_pdf"
                    style="width: 200px"
                    src="../../../assets/images/file_pdf.svg.webp"
                  />
                  <p v-if="fileExplain_pdf">{{ fileExplain_pdf }}</p>
                </div>
                <button @click="removeExplainImage">X</button>
              </div>
              <!--                            5-->
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3 float-right">
        <b-button @click="hideModal" variant="danger">{{
          $t("question_list.label.cancel")
        }}</b-button>
        <b-button
          @click="
            CreateQuestions();
            hideModal;
          "
          style="margin-left: 1rem"
          variant="primary"
          >{{ $t("question_list.label.edit") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      totalCharacterExplain: null,
      fileExplain_img: "",
      fileExplain_pdf: "",
      isImage: null,
      namePdf: "",
      explain_path_notVuex: "",
      explain_notVuex: ""
    };
  },
  computed: {
    ...mapState("question", [
      "editQuestion",
      "explain",
      "explain_path",
      "explain_img_preview",
      "explain_pdf_preview"
    ])
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("modal-explain-edit");
    },
    charCount: function() {
      this.totalCharacterExplain = this.explain_notVuex.length;
    },
    handleExplainUpload(e) {
      // check validate
      let fileUpload = e.target.files[0].name.split(".");
      let typeOfFile = fileUpload[fileUpload.length - 1];

      if (
        typeOfFile === "pdf" ||
        typeOfFile === "jpg" ||
        typeOfFile === "jpeg" ||
        typeOfFile === "png"
      ) {
        if (typeOfFile === "pdf") {
          const file = e.target.files[0];
          this.fileExplain_pdf = file.name;
          this.explain_path_notVuex = file;
          this.isImage = false;
        } else {
          const file = e.target.files[0];
          this.fileExplain_img = URL.createObjectURL(file);
          this.explain_path_notVuex = file;
          this.isImage = true;
        }
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    removeExplainImage: function() {
      this.explain_path_notVuex = "";
      this.editQuestion.data.explain_path = "";
      this.editQuestion.data.explain_s3 = "";
      this.fileExplain_img = "";
      this.fileExplain_pdf = "";
    },
    async CreateQuestions() {
      if (this.explain_notVuex) {
        if (this.explain_notVuex.length > 1500) {
          this.$bvToast.toast(`msg["E_UC1.2_07"]`, {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
          });
          return;
        }
      }
      let data = [];
      // giai thich
      this.editQuestion.data.explain = this.explain_notVuex;
      // file giai thich -> co sua : khong sua
      this.editQuestion.data.explain_path = this.explain_path_notVuex
        ? this.explain_path_notVuex
        : this.editQuestion.data.explain_path;

      // luu vao state
      data["explain"] = this.explain_notVuex;
      // co thay doi path ?
      data["explain_path"] = this.explain_path_notVuex
        ? this.explain_path_notVuex
        : this.editQuestion.data_explain_path;
      // co thay doi anh preview ? cu~ : moi
      // co thay doi pdf preview ? cu~ : moi
      if (this.isImage === false) {
        data["explain_pdf_preview"] =
          this.fileExplain_pdf == ""
            ? this.editQuestion.data.explain_s3
            : this.fileExplain_pdf;
        data["explain_img_preview"] = "";
      } else {
        data["explain_pdf_preview"] = "";
        data["explain_img_preview"] =
          this.fileExplain_img == ""
            ? this.editQuestion.data.explain_s3
            : this.fileExplain_img;
      }
      await this.$store.dispatch("question/setExplain", data);

      this.$bvModal.hide("modal-explain-edit");
      this.$root.$loading.start();
      this.$root.$loading.finish();
    }
  },
  async created() {
    let questionEdit = this.editQuestion.data;
    if (questionEdit.explain) {
      this.explain_notVuex = questionEdit.explain;
      this.totalCharacterExplain = questionEdit.explain.length;
    }
    if (questionEdit.explain_path) {
      this.fileExplain_img = this.explain_img_preview;
      this.fileExplain_pdf = this.explain_pdf_preview;
    }
    if (questionEdit.explain_s3) {
      if (this.editQuestion.data.explain_path.includes(".pdf")) {
        this.isImage = false;
        this.namePdf = this.editQuestion.data.explain_path.substr(13);
      } else {
        this.isImage = true;
      }
    }
  }
};
</script>
<style>
@import "../../../assets/scss/Questions.scss";

* {
  font-size: 15px;
}
.explain {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  padding: 21px;
}
.explain-textArena {
  position: relative;
  margin: 20px 0px;
}

.explain-textArena textarea {
  padding: 10px;
  border-radius: 2px;
}
.explain-textArena span {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
</style>
